import React from "react";
import teamscxLogo from "@/assets/images/teamscx.png";

const NoQueueAccessNotice: React.FC = () => {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center text-center text-base font-normal leading-normal text-teamscx-primary">
      <img src={teamscxLogo} alt="TeamsCX Logo" className="mb-6 rounded-lg" width={60} height={60} />
      <p className="m-0 px-4 font-semibold">You don&apos;t have permission to view this tab.</p>
      <p className="m-0 px-4">Please contact your administrator to request access.</p>
    </div>
  );
};

export default NoQueueAccessNotice;
